/** @internal */
export const DecodeExceptionTypeId = /*#__PURE__*/Symbol.for("@effect/data/Encoding/errors/Decode");
/** @internal */
export const DecodeException = (input, message) => ({
  _tag: "DecodeException",
  [DecodeExceptionTypeId]: DecodeExceptionTypeId,
  input,
  message
});
/** @internal */
export const isDecodeException = u => typeof u === "object" && u != null && DecodeExceptionTypeId in u;
/** @interal */
export const encoder = /*#__PURE__*/new TextEncoder();
/** @interal */
export const decoder = /*#__PURE__*/new TextDecoder();
//# sourceMappingURL=Common.mjs.map